import { H1 } from '@montel/montelpro-shared-components-v2';
import { FunctionComponent, useEffect } from 'react';
import BundleForm from './BundleForm';
import { useSearchParams } from 'react-router-dom';
import { useBundleFormContext } from './BundleForm/BundleFormContext';

const CreateBundlePage: FunctionComponent = () => {
	const [searchParams] = useSearchParams();
	const companyId = searchParams.get('companyId');

	const { setCompanyId } = useBundleFormContext();

	useEffect(() => {
		if (companyId) {
			setCompanyId(Number(companyId));
		}
	}, [companyId, setCompanyId]);

	return (
		<>
			<H1>Create subscription bundle</H1>
			<BundleForm />
		</>
	);
};

export default CreateBundlePage;
